import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { DataSelectBox } from "../models/selectbox";
import intance from "../utils/axios";

export const layDsThuLaoKCT = async () => {
    var rs: Array<any> = []
    await intance.get(ApiPaths.thuLaoKhongChuyenTrach.layDs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};

export const layDsThuLaoKCTTheoNam = async (nam?: number) => {
    let url = ApiPaths.thuLaoKhongChuyenTrach.layDsTheoNam;
    if (nam) {
        url += `?nam=${nam}`;
    }
    let rs: any[] = [];
    await intance.get(url)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
            else throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
    return rs;
};

export const tinhThuLaoKCT = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.thuLaoKhongChuyenTrach.tinhThuLao, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};

export const luuThuLaoKCT = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.thuLaoKhongChuyenTrach.luu, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
};

export const thuLaoKhongChuyenTrachGetById = async (id: number) => {
    var rs: any;
    await intance.get(`${ApiPaths.thuLaoKhongChuyenTrach.layChiTiet}?id=${id}`).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const convertDataDsThuLaoKhongChuyenTrach = async (nam: number) => {
    var rs: Array<DataSelectBox> = []
    await intance.get(ApiPaths.thuLaoKhongChuyenTrach.layDs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                let data = res.data.duLieu;
                var danhSach = data.filter((i: any) => i.nam === nam && i.loaiThuLao !== 2);
                if (danhSach != null && danhSach.length > 0) {
                    rs = danhSach.map((_item: any) => {
                        return {
                            value: _item.id,
                            label: `${_item.thoiGian} (${_item.ten})`
                        }
                    });
                }
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
}


export const trinhThuLaoKhongChuyenTrach = async (id: any) => {
    await intance.post(ApiPaths.thuLaoKhongChuyenTrach.trinhThuLaoKhongChuyenTrach + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const duyetThuLaoKhongChuyenTrach = async (id: any) => {
    await intance.post(ApiPaths.thuLaoKhongChuyenTrach.duyetThuLaoKhongChuyenTrach + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const xacNhanThuLaoKhongChuyenTrach = async (id: any) => {
    await intance.post(ApiPaths.thuLaoKhongChuyenTrach.xacNhanThuLaoKhongChuyenTrach + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const xoaThuLaoKhongChuyenTrach = async (id: any) => {
    await intance.post(ApiPaths.thuLaoKhongChuyenTrach.xoaThuLaoKhongChuyenTrach + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}
export const xuatExcelThuLaoKhongChuyenTrach = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.thuLaoKhongChuyenTrach.xuatExcelThuLaoKhongChuyenTrach + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};